import React from 'react'
import { Box, Container, Typography, Divider, Link as MuiLink } from '@mui/material'
import { useTranslation } from 'react-i18next'

const Impressum: React.FC = () => {
  const { i18n } = useTranslation()
  const isDe = (i18n.resolvedLanguage || i18n.language || 'de').startsWith('de')

  return (
    <Container sx={{ maxWidth: 900, mx: 'auto' }}>
      {isDe ? (
        <>
          <Box sx={{ mb: 3 }}>
            <Typography variant="h3" gutterBottom>Impressum</Typography>
            <Typography color="text.secondary">Angaben gemäß § 5 TMG</Typography>
          </Box>

          <Box sx={{ mb: 3 }}>
            <Typography variant="h5" gutterBottom>Anbieter</Typography>
            <Typography>
              {/* Bitte mit echten Daten ersetzen */}
              Name/Firma<br/>
              Straße Hausnummer<br/>
              PLZ Ort<br/>
              Deutschland
            </Typography>
          </Box>

          <Box sx={{ mb: 3 }}>
            <Typography variant="h5" gutterBottom>Kontakt</Typography>
            <Typography>
              Telefon: <MuiLink href="tel:+49">+49</MuiLink><br/>
              E‑Mail: <MuiLink href="mailto:kontakt@example.com">kontakt@example.com</MuiLink>
            </Typography>
          </Box>

          <Box sx={{ mb: 3 }}>
            <Typography variant="h6" gutterBottom>Vertretungsberechtigt</Typography>
            <Typography>
              {/* Nur bei juristischen Personen relevant; sonst entfernen */}
              Vertretungsberechtigte Person(en): Vorname Nachname
            </Typography>
          </Box>

          <Box sx={{ mb: 3 }}>
            <Typography variant="h6" gutterBottom>Umsatzsteuer-ID</Typography>
            <Typography>
              {/* Falls vorhanden */}
              Umsatzsteuer‑Identifikationsnummer gemäß § 27 a UStG: DE‑XXXXXXXXX
            </Typography>
          </Box>

          <Box sx={{ mb: 3 }}>
            <Typography variant="h6" gutterBottom>Inhaltlich verantwortlich</Typography>
            <Typography>
              Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:<br/>
              Vorname Nachname, Straße Hausnummer, PLZ Ort, Deutschland
            </Typography>
          </Box>

          <Divider sx={{ my: 4 }} />

          <Box sx={{ mb: 3 }}>
            <Typography variant="h5" gutterBottom>Haftung für Inhalte</Typography>
            <Typography color="text.secondary">
              Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.
              Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen
              oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
              Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis
              einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
            </Typography>
          </Box>

          <Box sx={{ mb: 3 }}>
            <Typography variant="h5" gutterBottom>Haftung für Links</Typography>
            <Typography color="text.secondary">
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Daher können wir für diese fremden Inhalte
              auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
              Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der
              Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer
              Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
            </Typography>
          </Box>

          <Box sx={{ mb: 3 }}>
            <Typography variant="h5" gutterBottom>Urheberrecht</Typography>
            <Typography color="text.secondary">
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung,
              Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen
              Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf
              dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet und Inhalte als solche gekennzeichnet. Sollten Sie
              trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen
              werden wir derartige Inhalte umgehend entfernen.
            </Typography>
          </Box>

          <Box sx={{ mb: 3 }}>
            <Typography variant="h5" gutterBottom>EU‑Streitschlichtung</Typography>
            <Typography color="text.secondary">
              Die Europäische Kommission stellt eine Plattform zur Online‑Streitbeilegung (OS) bereit:
              <br/>
              <MuiLink href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">
                https://ec.europa.eu/consumers/odr
              </MuiLink>.
              Unsere E‑Mail‑Adresse finden Sie oben im Impressum.
            </Typography>
          </Box>

          <Box sx={{ mb: 3 }}>
            <Typography variant="h5" gutterBottom>Verbraucherstreitbeilegung / Universalschlichtungsstelle</Typography>
            <Typography color="text.secondary">
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
            </Typography>
          </Box>
        </>
      ) : (
        <>
          <Box sx={{ mb: 3 }}>
            <Typography variant="h3" gutterBottom>Imprint</Typography>
            <Typography color="text.secondary">Information pursuant to § 5 TMG</Typography>
          </Box>

          <Box sx={{ mb: 3 }}>
            <Typography variant="h5" gutterBottom>Provider</Typography>
            <Typography>
              {/* Replace with real details */}
              Name/Company<br/>
              Street No.<br/>
              ZIP City<br/>
              Germany
            </Typography>
          </Box>

          <Box sx={{ mb: 3 }}>
            <Typography variant="h5" gutterBottom>Contact</Typography>
            <Typography>
              Phone: <MuiLink href="tel:+49">+49</MuiLink><br/>
              Email: <MuiLink href="mailto:contact@example.com">contact@example.com</MuiLink>
            </Typography>
          </Box>

          <Box sx={{ mb: 3 }}>
            <Typography variant="h6" gutterBottom>Authorized representative</Typography>
            <Typography>
              {/* For legal entities; remove if not applicable */}
              Authorized representative(s): Firstname Lastname
            </Typography>
          </Box>

          <Box sx={{ mb: 3 }}>
            <Typography variant="h6" gutterBottom>VAT ID</Typography>
            <Typography>
              VAT identification number according to § 27 a UStG: DE‑XXXXXXXXX
            </Typography>
          </Box>

          <Box sx={{ mb: 3 }}>
            <Typography variant="h6" gutterBottom>Responsible for content</Typography>
            <Typography>
              Responsible according to § 55 Abs. 2 RStV:<br/>
              Firstname Lastname, Street No., ZIP City, Germany
            </Typography>
          </Box>

          <Divider sx={{ my: 4 }} />

          <Box sx={{ mb: 3 }}>
            <Typography variant="h5" gutterBottom>Liability for contents</Typography>
            <Typography color="text.secondary">
              As a service provider, we are responsible for our own content on these pages in accordance with general
              laws (§ 7 para. 1 TMG). According to §§ 8 to 10 TMG, we are not obliged to monitor transmitted or stored
              third‑party information or to investigate circumstances that indicate illegal activity. Obligations to
              remove or block the use of information under general laws remain unaffected. However, liability in this
              respect is only possible from the time of knowledge of a specific infringement. If we become aware of any
              such violations, we will remove this content immediately.
            </Typography>
          </Box>

          <Box sx={{ mb: 3 }}>
            <Typography variant="h5" gutterBottom>Liability for links</Typography>
            <Typography color="text.secondary">
              Our website contains links to external third‑party websites, the contents of which we have no influence
              over. Therefore, we cannot assume any liability for these external contents. The respective provider or
              operator of the pages is always responsible for the contents of the linked pages. The linked pages were
              checked for possible legal violations at the time of linking; illegal contents were not recognizable at the
              time of linking. Permanent monitoring of the contents of the linked pages is not reasonable without
              concrete evidence of an infringement. If we become aware of legal violations, we will remove such links
              immediately.
            </Typography>
          </Box>

          <Box sx={{ mb: 3 }}>
            <Typography variant="h5" gutterBottom>Copyright</Typography>
            <Typography color="text.secondary">
              The content and works created by the site operators on these pages are subject to German copyright law.
              Duplication, processing, distribution and any kind of exploitation outside the limits of copyright require
              the written consent of the respective author or creator. Downloads and copies of this site are only
              permitted for private, non‑commercial use. Insofar as the content on this site was not created by the
              operator, the copyrights of third parties are respected and content is marked as such. Should you become
              aware of a copyright infringement, please inform us accordingly. If we become aware of any infringements,
              we will remove such content immediately.
            </Typography>
          </Box>

          <Box sx={{ mb: 3 }}>
            <Typography variant="h5" gutterBottom>EU online dispute resolution</Typography>
            <Typography color="text.secondary">
              The European Commission provides a platform for online dispute resolution (ODR):
              <br/>
              <MuiLink href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">
                https://ec.europa.eu/consumers/odr
              </MuiLink>.
              Our email address can be found above in the imprint.
            </Typography>
          </Box>

          <Box sx={{ mb: 3 }}>
            <Typography variant="h5" gutterBottom>Consumer dispute resolution</Typography>
            <Typography color="text.secondary">
              We are not willing or obliged to participate in dispute resolution proceedings before a consumer
              arbitration board.
            </Typography>
          </Box>
        </>
      )}
    </Container>
  )
}

export default Impressum
